import { render, staticRenderFns } from "./UpdateEffective.vue?vue&type=template&id=199b8b74&"
import script from "./UpdateEffective.vue?vue&type=script&lang=js&"
export * from "./UpdateEffective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports